import { render, staticRenderFns } from "./TechnicalSheet.vue?vue&type=template&id=63bd1d47&"
import script from "./TechnicalSheet.vue?vue&type=script&lang=js&"
export * from "./TechnicalSheet.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bd1d47')) {
      api.createRecord('63bd1d47', component.options)
    } else {
      api.reload('63bd1d47', component.options)
    }
    module.hot.accept("./TechnicalSheet.vue?vue&type=template&id=63bd1d47&", function () {
      api.rerender('63bd1d47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/fragments/TechnicalSheet.vue"
export default component.exports